import Vue from 'vue';
import Vuetify from 'vuetify';
import VueRouter from 'vue-router';
import 'vuetify/dist/vuetify.min.css';
import App from './App.vue';
import Home from './pages/Home';
import CreateHotel from './pages/Hotel/CreateHotel';
import HotelList from './pages/Hotel/HotelList';
import { VueMaskDirective } from 'v-mask';
import { VMoney } from 'v-money';
import axios from 'axios';
import EditHotel from './pages/Hotel/EditHotel';
import ReserveList from './Reserve/ReserveList';
import DetailReserve from './Reserve/ReserveDetails/ReserveDetails.vue';
import HotelListChanges from './pages/Hotel/HotelListChanges';
import PointOfSaleList from './pages/PointOfSale/PointOfSaleList';
import RelatedFaresList from './pages/PointOfSale/RelatedFaresList';
import UserList from './pages/User/UserList';
import GeneralReport from './pages/Reports/GeneralReport.vue';
import HotelsReport from './pages/Reports/HotelsReport.vue';
import EmittersReport from './pages/Reports/EmittersReport.vue';
import GuestsReport from './pages/Reports/GuestsReport.vue';
import PointsOfSaleReport from './pages/Reports/PointsOfSaleReport.vue';
import PendingCardsReport from './pages/Reports/PendingCardsReport.vue';
import HotelPendingChangesList from './pages/HotelPendingChanges/HotelPendingChangesList.vue';
import OwnerCreation from './pages/Hotel/OwnerCreation.vue';
import FormLayout from './layouts/FormLayout.vue';
import HotelOwnerActionsLayout from './layouts/HotelOwnerActionsLayout.vue';
import UnavailableLinkCreate from './pages/Hotel/UnavailableLinkCreate.vue';
import HotelsToApprove from './pages/HotelsToApprove/HotelsToApprove.vue';
import OwnerCreationSuccess from './pages/Hotel/OwnerCreationSuccess.vue';
import SessionExpiredDialog from './components/Dialog/SessionExpiredDialog.vue';
import OwnerCreationPreRegistration from './pages/Hotel/OwnerCreationPreRegistration.vue';
import Permissions from './pages/Permissions/PermissionsView.vue';
import PermissionPlugin from './plugins/PermissionPlugin';
import ResponseDialog from './components/Dialog/ResponseDialog.vue';
import CancelReserveWithReasons from "./pages/HotelOwnerActions/CancelReserveWithReasons.vue";
import ReserveNotFound from './pages/HotelOwnerActions/ReserveNotFound.vue';
import UpdateFares from "./pages/HotelOwnerActions/UpdateFares.vue";
import HotelAccessTokenError from "./pages/HotelOwnerActions/HotelAccessTokenError.vue";

const vuetify = new Vuetify();

Vue.use(Vuetify);
Vue.use(VueRouter);
Vue.directive('mask', VueMaskDirective);
Vue.directive('money', VMoney);
window.axios = axios;

Vue.component('SessionExpiredDialog', SessionExpiredDialog);
Vue.component('ResponseDialog', ResponseDialog);

Vue.use(PermissionPlugin);

Vue.prototype.$simpleDialog = function(dialogText, dialogType = 'info') {
    const app = this.$root.$children[0];
    if (app && app.$refs.simpleDialog) {
        app.$refs.simpleDialog.open(dialogText, dialogType);
    }
};

function adminGuard(to, from, next) {
    const userPermissions = JSON.parse(document.getElementById('app').dataset.userPermissions || '[]');

    if (to.meta && to.meta.permissions) {
        const hasPermission = to.meta.permissions.some(permission =>
            userPermissions.includes(permission) || permission === '*'
        );

        if (!hasPermission) {
            if (window.$toast) {
                window.$toast({
                    text: 'Você não possui permissão para acessar este recurso.',
                    color: 'error',
                });
            }
            return next('/');
        }
    }

    next();
}

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/initial-form',
            component: FormLayout,
            children: [
                {
                    path: '/',
                    name: 'hotelPreRegistration',
                    component: OwnerCreationPreRegistration,
                    meta: {
                        hideSidebar: true,
                        ownerCreation: true,
                        title: 'Pré Cadastro de hotel'
                    },
                }
            ]
        },
        {
            path: '/new-hotel/:externalId',
            component: FormLayout,
            children: [
                {
                    path: '/',
                    name: 'newHotel',
                    component: OwnerCreation,
                    meta: {
                        hideSidebar: true,
                        ownerCreation: true,
                        title: 'Cadastro de hotel'
                    },
                },
                {
                    path: 'unavailable',
                    name: 'unavailableLink',
                    component: UnavailableLinkCreate,
                    meta: {
                        hideSidebar: true,
                        title: 'Link expirado ou inexistente!'
                    }
                },
                {
                    path: 'success',
                    name: 'ownerCreationSuccess',
                    component: OwnerCreationSuccess,
                    meta: {
                        hideSidebar: true,
                        title: 'Cadastro realizado com sucesso!'
                    }
                }
            ]
        },
        {
            path: '/hotel-access-error',
            component: HotelOwnerActionsLayout,
            children: [
                {
                    path: '/',
                    name: 'hotelAccessTokenError',
                    component: HotelAccessTokenError,
                    meta: {
                        hideSidebar: true,
                        title: ''
                    },
                }
            ]
        },
        {
            path: '/hotel/update-fares/:tokenHash',
            component: HotelOwnerActionsLayout,
            children: [
                {
                    path: '/',
                    name: 'hotelOwnerFaresUpdate',
                    component: UpdateFares,
                    meta: {
                        hideSidebar: true,
                        title: 'Atualização de Tarifas de Hotel'
                    },
                }
            ]
        },
        {
            path: '/api/booking/cancel/:hashId',
            component: HotelOwnerActionsLayout,
            children: [
                {
                    path: '/',
                    name: 'cancelBookingWithReasons',
                    component: CancelReserveWithReasons,
                    meta: {
                        hideSidebar: true,
                        title: 'Revisão de Cancelamento'
                    },
                },
                {
                    path: 'reserve-not-found',
                    name: 'reserveNotFound',
                    component: ReserveNotFound,
                    meta: {
                        hideSidebar: true,
                        title: 'Identificador da reserva não encontrado'
                    }
                },
            ]
        },
        {
            path: '/create-hotel',
            name: 'createHotel',
            component: CreateHotel,
        },
        {
            path: '/edit-hotel/:id',
            name: 'editHotel',
            component: EditHotel,
        },
        {
            path: '/hotel-list',
            name: 'hotelList',
            component: HotelList,
        },
        {
            path: '/hotels-approve',
            name: 'hotelsApprove',
            component: HotelsToApprove,
        },
        {
            path: '/reserve-list',
            name: 'reserveList',
            component: ReserveList,
        },
        {
            path: '/detail-reserve/:id',
            name: 'detailReserve',
            component: DetailReserve,
        },
        {
            path: '/register',
            name: 'registerUser',
            component: Home,
        },
        {
            path: '/hotel-list-changes/:id',
            name: 'hotelListChanges',
            component: HotelListChanges,
        },
        {
            path: '/list-point-of-sale',
            name: 'pointOfSaleList',
            component: PointOfSaleList,
        },
        {
            path: '/fares-on-deal/:id',
            name: 'relatedFaresList',
            component: RelatedFaresList,
        },
        {
            path: '/user-list',
            name: 'userList',
            component: UserList,
        },
        {
            path: '/general-report',
            name: 'generalReport',
            component: GeneralReport,
        },
        {
            path: '/hotels-report',
            name: 'hotelsReport',
            component: HotelsReport,
        },
        {
            path: '/emitters-report',
            name: 'emittersReport',
            component: EmittersReport,
        },
        {
            path: '/guests-report',
            name: 'guestsReport',
            component: GuestsReport,
        },
        {
            path: '/points-of-sale-report',
            name: 'pointsOfSaleReport',
            component: PointsOfSaleReport,
        },
        {
            path: '/pending-cards-report',
            name: 'pendingCardsReport',
            component: PendingCardsReport,
        },
        {
            path: '/hotels-pending-changes',
            name: 'hotelPendingChangesList',
            component: HotelPendingChangesList,
        },
        {
            path: '/permissions',
            name: 'permissions',
            component: Permissions,
            beforeEnter: adminGuard,
            meta: {
                permissions: ['manage.permissions'],
            }
        }
    ]
});

const app = new Vue({
    el: '#app',
    components: { App, SessionExpiredDialog },
    router,
    vuetify,
    data: {
        sessionExpired: false,
    },
});
